import SvgIcon from 'common/components/svg-icon';


const GridIcon = (props) => (
    <SvgIcon
        height='24'
        viewBox='0 0 400 320'
        width='24'
        { ...props }>
        <path d='M50.65.44H15.2a15.2,15.2,0,0,0,0,30.39H50.65a15.2,15.2,0,1,0,0-30.39Zm0,146.9H15.2a15.2,15.2,0,0,0,0,30.39H50.65a15.2,15.2,0,1,0,0-30.39Zm0,141.83H15.2a15.2,15.2,0,0,0,0,30.39H50.65a15.2,15.2,0,1,0,0-30.39Z' />
        <path d='M162,.44H126.58a15.2,15.2,0,0,0,0,30.39H162A15.2,15.2,0,0,0,162,.44Zm0,146.9H126.58a15.2,15.2,0,0,0,0,30.39H162a15.2,15.2,0,1,0,0-30.39Zm0,141.83H126.58a15.2,15.2,0,0,0,0,30.39H162a15.2,15.2,0,0,0,0-30.39Z' />
        <path d='M273.42.44H238a15.2,15.2,0,0,0,0,30.39h35.46a15.2,15.2,0,0,0,0-30.39Zm0,146.9H238a15.2,15.2,0,0,0,0,30.39h35.46a15.2,15.2,0,1,0,0-30.39Zm0,141.83H238a15.2,15.2,0,0,0,0,30.39h35.46a15.2,15.2,0,1,0,0-30.39Z' />
        <path d='M384.8.44H349.35a15.2,15.2,0,0,0,0,30.39H384.8a15.2,15.2,0,0,0,0-30.39Zm0,146.9H349.35a15.2,15.2,0,1,0,0,30.39H384.8a15.2,15.2,0,0,0,0-30.39Zm0,141.83H349.35a15.2,15.2,0,1,0,0,30.39H384.8a15.2,15.2,0,0,0,0-30.39Z' />
    </SvgIcon>
);


export default GridIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg-icon/grid.js